import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';
import { getAllCustomerLinks } from './getAllCustomerLinks';

export const DELETE_CUSTOMER_LINK_REQUEST = 'DELETE_CUSTOMER_LINK_REQUEST';
export const DELETE_CUSTOMER_LINK_SUCCESS = 'DELETE_CUSTOMER_LINK_SUCCESS';
export const DELETE_CUSTOMER_LINK_FAILURE = 'DELETE_CUSTOMER_LINK_FAILURE';

function request() {
  return {
    type: DELETE_CUSTOMER_LINK_REQUEST
  };
}

function receive() {
  return {
    type: DELETE_CUSTOMER_LINK_SUCCESS,
  };
}

function fail() {
  return {
    type: DELETE_CUSTOMER_LINK_FAILURE,
  };
}

export function removeCustomerLink(linkId, customerId) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .removeCustomerLink(linkId, customerId)
      .then((response) => {
        dispatch(receive());
        toastr.success('Success', 'Shareholder Link removed successfully');
        dispatch(getAllCustomerLinks(customerId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, fail, true));
        }
      });
    return promise();
  };
}
